<app-header [hasHierarchyDropdown]="false" (backAction)="goToHome()"></app-header>
<app-wizard></app-wizard>
<div class="fd-accreditation-form__container">
     <div class="forms">
          <router-outlet></router-outlet>
     </div>
</div>
